/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/common/material/material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProjectSchedulingComponent } from './project-scheduling.component';
import { WbsSyncService } from './services/wbs-sync.service';
import { WbsSyncComponent } from './components/wbs-sync.component';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';
import { SharedUIMaterialModule } from 'src/app/shared/ui/material/shared-ui-material.module';
import { ExternalScheduleComponent } from './components/external-schedule.component';
import { ExternalScheduleService } from 'src/app/services/external-schedule.service';
import { PresentationModule } from '../../common/presentation-components/presentation.module';

@NgModule({
	declarations: [ProjectSchedulingComponent, WbsSyncComponent, ExternalScheduleComponent],
	imports: [
		CommonModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		DialogReusableModule,
		SharedUIMaterialModule,
		PresentationModule,
	],
	exports: [ProjectSchedulingComponent],
	providers: [WbsSyncService, ExternalScheduleService],
})
export class ProjectSchedulingModule {}
